var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("11")]),_c('v-btn',{on:{"click":_vm.test}},[_vm._v("test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }